import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';


import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MaterialModule} from '../../material/material.module';
import {FlexLayoutModule} from '@angular/flex-layout';
import {Ng2SearchPipeModule} from 'ng2-search-filter';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {NgSelectComponent, NgSelectModule} from '@ng-select/ng-select';

//components
import {EditSuggestionFieldComponent} from "./edit-suggestion-field/edit-suggestion-field.component";
import {MatAutoSearchComponent} from './mat-auto-search/mat-auto-search.component';
import {FileDragNDropDirective} from './file-field/file-drag-n-drop.directive';
import {BaseControlValueAccessor} from './base_control_value_accessor/base';
import {AutoSearchComponent} from './auto-search/auto-search.component';
import {FileFieldComponent} from './file-field/file-field.component';
import {DateFieldComponent} from './date-field/date-field.component';
import {MonthYearFieldComponent} from './month-year-field/month-year-field.component';
import {NumberFieldComponent} from './number-field/number-field.component';
import {PercentFieldComponent} from './percent-field/percent-field.component';
import {PhoneFieldComponent} from './phone-field/phone-field.component';
import {SelectFieldComponent} from './select-field/select-field.component';
import {TextFieldComponent} from './text-field/text-field.component';
import {ToggleSelectComponent} from './toggle-select/toggle-select.component';
import {NewMoneyFieldComponent} from "./new_money-field/new-money-field.component";
import {MultipleEmailFieldComponent} from "./multiple-email-field/multiple-email-field.component";
import {PasswordFieldComponent} from "./password-field/password-field.component";
import {SuperLocationComponent} from "./super-location/super-location.component";
import {CountryFieldComponent} from './country-field/country-field.component';
import {ViewDataFieldComponent} from './view-data-field/view-data-field.component';
import {SuperLocationDialogComponent} from './super-location/super-location-dialog/super-location-dialog.component';
import {CurrencySearchComponent} from './currency-search/currency-search.component';
import {MoneyFieldComponent} from './money-field/money-field.component';
import {ChipperComponent} from './chipper/chipper.component';
// import { ReturnContainersComponent } from '../external-dashboards/return-containers/return-containers.component';
import {MultiselectAutocompleteComponent} from './multiselect-autocomplete/multiselect-autocomplete.component';
import {ReplyDocStationComponent} from './reply-doc-station/reply-doc-station.component';
import {LoaderModule} from '../loader/loader.module';
import {MarkdownModule} from 'ngx-markdown';
import {DurationFieldComponent} from './duration-field/duration-field.component';
import {PipesModule} from 'src/app/pipes/pipes.module';
import {PasswordStrengthMeterComponent} from './password-strength-meter/password-strength-meter.component';
import {BankDetailsFormComponent} from './bank-details/bank-details.component';
import {ContactPersonsComponent} from './contact-persons/contact-persons.component';
import {MultiFieldComponent} from './multi-field/multi-field.component';
import {StickyNotesComponent} from './sticky-notes/sticky-notes.component';
import {GoToExternalAppComponent} from "./go-to-external-app/go-to-external-app.component";
import {InputNumberRangeFieldComponent} from './input-number-range-field/input-number-range-field.component';
import {DateRangeFieldComponent} from "./date-range-field/date-range-field.component";

@NgModule({
    declarations: [
        CountryFieldComponent,
        EditSuggestionFieldComponent,
        AutoSearchComponent,
        MatAutoSearchComponent,
        SuperLocationComponent,
        FileFieldComponent,
        FileDragNDropDirective,
        DateFieldComponent,
        MonthYearFieldComponent,
        NewMoneyFieldComponent,
        NumberFieldComponent,
        PercentFieldComponent,
        PhoneFieldComponent,
        SelectFieldComponent,
        TextFieldComponent,
        PasswordFieldComponent,
        MultipleEmailFieldComponent,
        ToggleSelectComponent,
        BaseControlValueAccessor,
        ViewDataFieldComponent,
        SuperLocationDialogComponent,
        CurrencySearchComponent,
        MoneyFieldComponent,
        ChipperComponent,
        // ReturnContainersComponent,
        MultiselectAutocompleteComponent,
        ReplyDocStationComponent,
        DurationFieldComponent,
        PasswordStrengthMeterComponent,
        BankDetailsFormComponent,
        ContactPersonsComponent,
        MultiFieldComponent,
        StickyNotesComponent,
        GoToExternalAppComponent,
        InputNumberRangeFieldComponent,
        DateRangeFieldComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        FlexLayoutModule,
        Ng2SearchPipeModule,
        DragDropModule,
        NgSelectModule,
        LoaderModule,
        MarkdownModule,
        PipesModule,
    ],
    exports: [
        CountryFieldComponent,
        EditSuggestionFieldComponent,
        AutoSearchComponent,
        MatAutoSearchComponent,
        SuperLocationComponent,
        FileFieldComponent,
        FileDragNDropDirective,
        DateFieldComponent,
        MonthYearFieldComponent,
        NewMoneyFieldComponent,
        NumberFieldComponent,
        PercentFieldComponent,
        PhoneFieldComponent,
        SelectFieldComponent,
        TextFieldComponent,
        PasswordFieldComponent,
        MultipleEmailFieldComponent,
        ToggleSelectComponent,
        BaseControlValueAccessor,
        NgSelectComponent,
        ViewDataFieldComponent,
        SuperLocationDialogComponent,
        MoneyFieldComponent,
        ChipperComponent,
        // ReturnContainersComponent,
        MultiselectAutocompleteComponent,
        ReplyDocStationComponent,
        DurationFieldComponent,
        PasswordStrengthMeterComponent,
        BankDetailsFormComponent,
        ContactPersonsComponent,
        MultiFieldComponent,
        StickyNotesComponent,
        GoToExternalAppComponent,
        CurrencySearchComponent,
        InputNumberRangeFieldComponent,
        DateRangeFieldComponent
    ]
})
export class FormFieldsModule {
}
